import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prescripteur-item',
  templateUrl: './prescripteur-item.component.html',
  styleUrls: ['./prescripteur-item.component.scss']
})
export class PrescripteurItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
